<div class="blob-background">
	<div class="blob one"></div>
	<div class="blob two"></div>
	<div class="blob three"></div>
	<div class="blob four"></div>
	<div class="blob five"></div>
	<div class="middle">
		<form>
			@if (!success) {
			<div class="floating-panel">
				<div class="branded-asset-logo"></div>
				<hr>
				<div class="mb-3 narrow">
					<label for="email">Email address</label>
					<input [(ngModel)]="email" id="email" name="email" type="email" autocomplete="email" placeholder="Email" class="form-control">
				</div>
				<div class="button-group narrow mt-3">
					<app-action-button submit [action]="Forgot" [context]="this" btnClass="full-green wider" [disabled]="!email" processing="Sending reset email...">Reset
						Password</app-action-button>
				</div>
				@if (!showMfa) {
				<div class="narrow">
					<a [routerLink]="['/login']">Return to login</a>
				</div>
				}
			</div>
			}
			@if (success) {
			<div class="floating-panel">
				<div class="branded-asset-logo"></div>
				<hr>
				<div>
					If {{email}} is a valid user, then a password reset email will be sent to that address. Follow the link in the email
					to reset your password.
				</div>
			</div>
			}
		</form>
	</div>
</div>